import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { DEFAULT_CONFIG } from '../constants';
import { BaseGraphQlClient } from '../graphql-client';
import { logException } from '../sentry/main';
export var BROWSE_USER_SETTINGS_KEY = 'internal.browse-users-allowed';
var buildTeamMembershipQuery = function buildTeamMembershipQuery(teamId, membershipState) {
  return {
    query: "query TeamMembership($teamId: String!, $membershipState: [TeamMembershipStatus]) {\n    TeamMembership: TeamMembership(teamId: $teamId, membershipStates: $membershipState) {\n      user: profile {\n        id,\n        fullName,\n        title,\n        avatarUrl,\n        timezone,\n        status\n      },\n      state:membershipStatus,\n      role,\n      membershipId {\n        teamId, memberId\n      }\n    }\n  }",
    variables: {
      teamId: teamId,
      membershipState: membershipState
    }
  };
};

/**
 * @type CloudUser
 * @property {string} avatarUrl
 * @property {string} id
 * @property {string} fullName
 * @property {string} title
 */

var buildUserQuery = function buildUserQuery(userId, cloudId) {
  return {
    query: "query CloudUser($userId: String!, $cloudId: String!) {\n    CloudUser(userId: $userId, cloudId: $cloudId) {\n      avatarUrl\n      id\n      fullName\n      title\n    }\n  }",
    variables: {
      userId: userId,
      cloudId: cloudId
    }
  };
};
var delay = function delay(millis) {
  return new Promise(function (resolve) {
    setTimeout(resolve, millis);
  });
};
export var DirectoryClient = /*#__PURE__*/function (_BaseGraphQlClient) {
  _inherits(DirectoryClient, _BaseGraphQlClient);
  var _super = _createSuper(DirectoryClient);
  function DirectoryClient(baseUrl, config) {
    _classCallCheck(this, DirectoryClient);
    return _super.call(this, "".concat(baseUrl, "/directory/graphql"), config);
  }
  _createClass(DirectoryClient, [{
    key: "setBaseUrl",
    value: function setBaseUrl(baseUrl) {
      this.setServiceUrl("".concat(baseUrl, "/directory/graphql"));
    }
  }, {
    key: "queryFeatureFlags",
    value: function () {
      var _queryFeatureFlags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(
      /**
       * @private
       * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
       */
      cloudId, flags) {
        var queryFeatureFlags, _yield$this$makeGraph, FeatureFlags;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              queryFeatureFlags = {
                query: "query FeatureFlags($cloudId: String!, $flags: [String]!) {\n        FeatureFlags(cloudId: $cloudId, flags: $flags) {\n          flag\n          enabled\n        }\n      }",
                variables: {
                  cloudId: this.getCloudId(cloudId),
                  flags: flags
                }
              };
              _context.next = 3;
              return this.makeGraphQLRequest(queryFeatureFlags, {
                operationName: 'FeatureFlags'
              });
            case 3:
              _yield$this$makeGraph = _context.sent;
              FeatureFlags = _yield$this$makeGraph.FeatureFlags;
              return _context.abrupt("return", FeatureFlags.map(function (_ref) {
                var flag = _ref.flag,
                  enabled = _ref.enabled;
                return [flag, enabled];
              }).reduce(function (acc, val) {
                return acc[val[0]] = val[1], acc;
              }, {}));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function queryFeatureFlags(_x, _x2) {
        return _queryFeatureFlags.apply(this, arguments);
      }
      return queryFeatureFlags;
    }()
  }, {
    key: "canRetryError",
    value: function canRetryError(pendingRetries, error) {
      return pendingRetries > 0 && !!error && _typeof(error) === 'object' && 'category' in error && error.category === 'NotFound';
    }

    /**
     * Get user information of all members of a team
     * @param {string} teamId
     * @returns {Promise}
     * @private
     * @deprecated use AGG instead
     */
  }, {
    key: "queryTeamMemberships",
    value: function queryTeamMemberships(teamId) {
      var _this = this;
      var membershipStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['FULL_MEMBER'];
      // eslint-disable-next-line no-console
      console.warn('Directory queryTeamMemberships is deprecated, use AGG instead');
      var teamMembershipsQuery = buildTeamMembershipQuery(teamId, membershipStatus);
      var performRequest = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var pendingRetries,
            backoffMaxDelay,
            _args2 = arguments;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                pendingRetries = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 3;
                backoffMaxDelay = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 2000;
                _context2.prev = 2;
                _context2.next = 5;
                return _this.makeGraphQLRequest(teamMembershipsQuery, {
                  operationName: 'TeamMembership'
                });
              case 5:
                return _context2.abrupt("return", _context2.sent);
              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                if (!_this.canRetryError(pendingRetries, _context2.t0)) {
                  _context2.next = 14;
                  break;
                }
                _context2.next = 13;
                return delay(backoffMaxDelay / pendingRetries);
              case 13:
                return _context2.abrupt("return", performRequest(pendingRetries - 1));
              case 14:
                throw _context2.t0;
              case 15:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[2, 8]]);
        }));
        return function performRequest() {
          return _ref2.apply(this, arguments);
        };
      }();
      return performRequest().then(function (_ref3) {
        var TeamMembership = _ref3.TeamMembership;
        return TeamMembership;
      });
    }

    /**
     * Get user information of all members of a team
     * @param {string} userId
     * @returns {Promise}
     */
  }, {
    key: "queryUser",
    value: function queryUser(userId,
    /**
     * @private
     * @deprecated don't need to pass param, value is taken from `this.getCloudId()` instead
     */
    cloudId) {
      var _this2 = this;
      var userQuery = buildUserQuery(userId, this.getCloudId(cloudId));
      var performRequest = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var pendingRetries,
            backoffMaxDelay,
            _args3 = arguments;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                pendingRetries = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 3;
                backoffMaxDelay = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 2000;
                _context3.prev = 2;
                _context3.next = 5;
                return _this2.makeGraphQLRequest(userQuery, {
                  operationName: 'CloudUser'
                });
              case 5:
                return _context3.abrupt("return", _context3.sent);
              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                if (!_this2.canRetryError(pendingRetries, _context3.t0)) {
                  _context3.next = 14;
                  break;
                }
                _context3.next = 13;
                return delay(backoffMaxDelay / pendingRetries);
              case 13:
                return _context3.abrupt("return", performRequest(pendingRetries - 1));
              case 14:
                throw _context3.t0;
              case 15:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[2, 8]]);
        }));
        return function performRequest() {
          return _ref4.apply(this, arguments);
        };
      }();
      return performRequest();
    }
  }]);
  return DirectoryClient;
}(BaseGraphQlClient);
/**
 * @deprecated As part of decommisioning pf-directoy
 */
export var directoryClient = new DirectoryClient(DEFAULT_CONFIG.stargateRoot, {
  logException: logException
});